import { render, staticRenderFns } from "./BlueskyImage.vue?vue&type=template&id=205f620a&functional=true&"
import script from "./BlueskyImage.vue?vue&type=script&lang=js&"
export * from "./BlueskyImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports